import { createSelector } from '@ngrx/store';
import { selectFeatureStore } from './generic.selectors';

export const selectFirstShiftAppointmentStatus = createSelector(
  selectFeatureStore,
  ({ firstShiftAppointmentStatus }) => firstShiftAppointmentStatus,
);

export const selectFirstShiftAppointmentAttendedDate = createSelector(
  selectFirstShiftAppointmentStatus,
  (firstShiftAppointmentStatus) => firstShiftAppointmentStatus.attendedDate,
);
